import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-1745">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-1746">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-1747" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-1748">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1749">
          <div className="flex justify-center mb-5" data-id="element-1750">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1751">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-1752" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-1753">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-1754">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-1755">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-1756" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-1757">
        {/* IMPORTANT WARNING */}
        <section data-id="element-1758">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-1759">
            <div className="flex items-start gap-4" data-id="element-1760">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-1761">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-1762" />
              </div>
              <div data-id="element-1763">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-1764">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-1765">
                  Estás A <span className="font-black text-white" data-id="element-1766">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-1767">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-1768">
          <div className="text-center mb-8" data-id="element-1769">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-1770">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1771" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-1772">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-1773">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1774">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1775">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1776" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1777">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-1778">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1779">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1780">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1781" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1782">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-1783">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1784">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1785">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1786" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1787">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-1788">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1789">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1790">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1791" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1792">
                <span className="font-bold text-white" data-id="element-1793">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-1794">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1795">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1796" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1797">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-1798">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-1799">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-1800">
            <div className="flex items-center gap-3 mb-8" data-id="element-1801">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1802">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1803" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-1804">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-1805">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-1806">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-1807">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1808">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-1809" />
                </div>
                <div data-id="element-1810">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1811">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1812">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-1813">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1814">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-1815" />
                </div>
                <div data-id="element-1816">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1817">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1818">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-1819">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1820">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-1821" />
                </div>
                <div data-id="element-1822">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1823">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1824">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-1825">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1826">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-1827" />
                </div>
                <div data-id="element-1828">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1829">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1830">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-1831">
          <div className="text-center mb-8" data-id="element-1832">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-1833">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1834" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-1835">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-1836">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-1837">
              <div className="flex gap-1 mb-4" data-id="element-1838">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1839" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1840" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1841" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1842" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1843" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-1844" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-1845">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1846">
                <p className="font-bold text-white text-sm" data-id="element-1847">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-1848">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-1849">
              <div className="flex gap-1 mb-4" data-id="element-1850">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1851" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1852" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1853" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1854" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1855" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-1856" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-1857">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1858">
                <p className="font-bold text-white text-sm" data-id="element-1859">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-1860">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-1861">
              <div className="flex gap-1 mb-4" data-id="element-1862">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1863" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1864" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1865" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1866" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1867" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-1868" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-1869">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1870">
                <p className="font-bold text-white text-sm" data-id="element-1871">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-1872">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-1873">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-1874">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-1875" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-1876">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1877" />
      <WhatsAppButton data-id="element-1878" />
    </div>;
}